/**
 * @file   src\Pages\CWOEmailTemplate.tsx
 * @brief  Email Template page.
 * @date   JUL, 2024
 * @author ZCO Engineer
 * @copyright (c) 2024, ZCO
 */

import { React,Container, Table, Button,  useOutletContext, useNavigate, useEffect, useState,  } from '../utils/thirdpartyComponents';
import EditIcon from '../assets/images/icons/editicon';
import { AppContextType } from '../interfaces/generalInterface';
import { pageURLs } from '../utils/pageUrls';
import axios from '../config/axiosConfig'
import { CWOEmailTemplateApi } from '../utils/apiUrls';
import { EmailTemplate } from '../interfaces/emailTemplateInterface';
import SmallLoader from '../components/SmallLoader';

const CWOEmailTemplate = () => {
    // Access the context
    const [loading,setLoading] = useState(false);
    const [emails, setEmails] = useState<EmailTemplate[]>();
    const {  updateData } = useOutletContext<AppContextType>();
    const navigate = useNavigate()

    useEffect(() => {
        handleUpdate()
        listEmailTemplates()
    }, [])

    // Update the data
    const handleUpdate = () => {
        updateData({ heading: "Email Templates", url: "", showBackButton: false, showMainMenu: true, activeLink: "" });
    };

    const listEmailTemplates = async () => {
        try {
            setLoading(true); // Show loader
            const { data } = await axios.get(CWOEmailTemplateApi.LIST_EMAIL_TEMPLATE);
            if (data.error === 0) {
                setEmails(data.data);
      
            // Initialize quantities with product information, including 'price'
         
          }
          } catch (error: any) {
            console.error('Error fetching hardware list:', error.message);
            throw new Error(error.response?.data?.message || error.message);
          }
          finally{
            setLoading(false);
          }
    }

  

    return (

        <div className='manage-carwash-container order-list-container'>
            <Container>
                <div className="cw-table-wrap">
                    <Table responsive className='m-0'>
                        <thead>
                            <tr>
                                <th>Template Name</th>
                                <th>Message</th>
                                <th>Action</th>
                            </tr>
                        </thead>
                        <tbody>
                            {emails && emails?.map((item) => (
                                <tr key={item.EmailTemplateID}>
                                    <td width="25%">{item.TemplateName}</td>
                                    <td width="55%">{item.EmailTemplateText}</td>
                                    <td width="25%"><Button variant="light" className="light-btn action-btn" title="Edit" onClick={() => navigate(`/${pageURLs.cwo_edittemplate}/${item.EmailTemplateID}`)}><EditIcon /></Button></td>
                                </tr>
                            ))}
                        </tbody>
                    </Table>
                </div>
                {loading && <SmallLoader />}
            </Container >
        </div >
    )
}

export default CWOEmailTemplate;
